// Types
import type { TBreadcrumbProps, TBreadcrumbSeparator } from './Breadcrumb.type';

export const BREADCRUMB_SEPARATORS: TBreadcrumbSeparator[] = ['slash', 'chevron']
export const BREADCRUMB_SEPARATOR: { [key in TBreadcrumbSeparator]: key } = {
	slash: 'slash',
	chevron: 'chevron'
};

export const BREADCRUMB_DEFAULT_PROPS: TBreadcrumbProps = {
	items: [],
	separator: BREADCRUMB_SEPARATOR.slash
}
